import { useState } from 'react';

export default function useDragAndDrop({ onFileSelect, enableDragDrop = true, allowMultiple = false, onInvalidFileType }) {
  const [isDragOver, setIsDragOver] = useState(false);

  const isImageFile = (file) => file.type.startsWith('image/');

  const handleDragEnter = (e) => {
    if (!enableDragDrop) return;
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(true);
  };

  const handleDragLeave = (e) => {
    if (!enableDragDrop) return;
    e.preventDefault();
    e.stopPropagation();

    // 실제로 컨테이너를 벗어났는지 확인
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX;
    const y = e.clientY;

    if (x < rect.left || x >= rect.right || y < rect.top || y >= rect.bottom) {
      setIsDragOver(false);
    }
  };

  const handleDragOver = (e) => {
    if (!enableDragDrop) return;
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    if (!enableDragDrop) return;
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(false);

    const files = e.dataTransfer.files;
    if (!files?.length) return;
    if (!onFileSelect) return;

    if (allowMultiple) {
      const allFiles = Array.from(files);
      const imageFiles = allFiles.filter(isImageFile);
      const invalidFiles = allFiles.filter(file => !isImageFile(file));

      if (invalidFiles.length > 0 && onInvalidFileType) {
        onInvalidFileType(invalidFiles);
      }

      if (imageFiles.length > 0) {
        onFileSelect(imageFiles);
      }
      return;
    }

    const file = files[0];
    if (isImageFile(file)) {
      onFileSelect(file);
    }
    else if (onInvalidFileType) {
      onInvalidFileType([file]);
    }
  };

  return {
    isDragOver,
    dragHandlers: {
      onDragEnter: handleDragEnter,
      onDragLeave: handleDragLeave,
      onDragOver: handleDragOver,
      onDrop: handleDrop,
    },
  };
}
